module.exports = __webpack_public_path__ + "app/components/global-arrow-board-map/global-arrow-board-map.view.html";